/**
 * Strip HTML tags for plain-text previews.
 * Tags are replaced by a space so block elements (</p><p>) don't glue
 * the last word of one sentence to the first word of the next.
 */
export function stripHtmlPreview(input?: string | null): string {
  if (!input) return "";
  return input
    .replace(/<br\s*\/?>/gi, " ")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();
}
